export default "__VITE_ASSET__22ed73d8__"